import CurrencyCode from "@/module/main/dto/CurrencyCodeEnum";
import BaseMapper from "@/module/main/service/BaseMapper";
import IAmountVat from "@/module/main/dto/IAmountVat";
import AmountVat from "@/module/main/dto/AmountVat";
import IAmount from "@/module/main/dto/financing-v1/IAmount";
import Amount from "@/module/main/dto/financing-v1/Amount";

abstract class BaseMapperV1 extends BaseMapper {
    protected createAmount(price: string, currencyCode: CurrencyCode): IAmount | undefined {
        let amount: IAmount | undefined = undefined;
        const priceNumber: number | undefined = this.stringToNumber(price);

        if (priceNumber != undefined) {
            amount = new Amount(Math.round(priceNumber * 100), currencyCode);
        }

        return amount;
    }

    protected createAmountVat(price: string, currencyCode: CurrencyCode, vatRate: string): IAmountVat | undefined {
        let amount: IAmountVat | undefined = undefined;
        const priceNumber: number | undefined = this.stringToNumber(price);
        const vatRateNumber: number | undefined = this.stringToNumber(vatRate);

        if (priceNumber != undefined && vatRateNumber != undefined) {
            amount = new AmountVat(priceNumber * 100, currencyCode, vatRateNumber);
        }

        return amount;
    }
}

export default BaseMapperV1;
